import * as THREE from 'three'

interface Spark {
  mesh: THREE.Mesh
  material: THREE.MeshBasicMaterial
  life: number
}

const LIFE = 0.12

/** A small pool of additive spark quads shown at bullet impact points. */
export default class Impacts {
  private readonly pool: Spark[] = []
  private next = 0
  private readonly tmp = new THREE.Vector3()

  constructor(scene: THREE.Scene, size = 16) {
    const geometry = new THREE.PlaneGeometry(3.5, 3.5)
    for (let i = 0; i < size; i++) {
      const material = new THREE.MeshBasicMaterial({
        color: 0xffdf70,
        transparent: true,
        blending: THREE.AdditiveBlending,
        depthWrite: false,
        side: THREE.DoubleSide,
      })
      const mesh = new THREE.Mesh(geometry, material)
      mesh.visible = false
      mesh.frustumCulled = false
      scene.add(mesh)
      this.pool.push({ mesh, material, life: 0 })
    }
  }

  /** Flash a spark at `point`, lifted off the surface along `normal`. */
  public spawn(point: THREE.Vector3, normal: THREE.Vector3): void {
    const s = this.pool[this.next]
    this.next = (this.next + 1) % this.pool.length
    s.mesh.position.copy(point).addScaledVector(normal, 0.6)
    s.mesh.lookAt(this.tmp.copy(s.mesh.position).add(normal))
    s.mesh.rotation.z = Math.random() * Math.PI
    s.mesh.scale.setScalar(0.6 + Math.random() * 0.6)
    s.mesh.visible = true
    s.material.opacity = 1
    s.life = LIFE
  }

  public update(dt: number): void {
    for (const s of this.pool) {
      if (s.life <= 0) continue
      s.life -= dt
      if (s.life <= 0) {
        s.mesh.visible = false
        continue
      }
      s.material.opacity = s.life / LIFE
    }
  }
}
